// extracted by mini-css-extract-plugin
export default {"spinner-rotation":"styles--spinner-rotation--23Udm"};